/**
 * Lab cases (NEW-WF-12): the Lab board (Late lane, filters), case create
 * from an appointment or the chart, send, receive (scan slip codes) and lab
 * setup. Route `/lab`; deep links `?patient=`, `?appointment=&new=1`.
 */
import { defineManifest } from '@velora/contracts';
import { LAB_PERMISSIONS as P } from '@velora/contracts/lab';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'lab',
    title: 'Lab cases',
    version: '0.1.0',
    owner: 'WP4-LAB',
    entitlementKey: null,
    permissions: [...new Set(Object.values(P))],
    routes: [
      {
        id: 'board',
        path: '/lab',
        title: 'Lab cases',
        officeScope: 'location',
        permission: P.view,
        readsPhi: true,
      },
    ],
    nav: [
      {
        label: 'Lab cases',
        group: 'schedule',
        routeId: 'board',
        icon: 'flask-conical',
        order: 60,
        permission: P.view,
      },
    ],
    commands: [
      {
        id: 'lab.board',
        title: 'Lab cases',
        keywords: ['lab', 'crown', 'denture', 'case', 'receive', 'late'],
        routeId: 'board',
        permission: P.view,
      },
    ],
    sseEntityKeys: ['lab_case'],
    phiReadPoints: ['lab.cases', 'lab.case', 'lab.procedures'],
  }),
  pages: {
    board: () => import('./LabBoardPage.js'),
  },
});
